export const FxIdStatsUnspecified = "Unspecified";
export const FxIdStatsTutorialStart = "TutorialStart";
export const FxIdStatsTutorialCompleted = "TutorialCompleted";
export const FxIdStatsTutorialSkip = "TutorialSkip";
export const FxIdStatsTutorialStep = "TutorialStep";
export class FxIdStats {
    ProcessStat(stat) {
        const result = { type: FxIdStatsUnspecified, event: stat };
        if (stat.section === "tutorial" && stat.type === "step" && stat.name === "start") {
            result.type = FxIdStatsTutorialStart;
        }
        else if (stat.section === "tutorial" && stat.type === "step" && stat.name === "completed") {
            result.type = FxIdStatsTutorialCompleted;
        }
        else if (stat.section === "tutorial" && stat.type === "step" && stat.name === "skip") {
            result.type = FxIdStatsTutorialSkip;
        }
        else if (stat.section === "tutorial" && stat.type === "step" && stat.name === "step") {
            result.type = FxIdStatsTutorialStep;
        }
        return result;
    }
}
